

<button type="button" (click)="generatePdf()" type="reset"  *ngIf="!isDownloadOrder" class="add-button btn btn-primary" translate aria-label="Center Align"> <em class="fas fa-download mr-2"></em>lblDownload </button>
<button type="button" (click)="printPdf(1)" type="reset"  *ngIf="isDownloadOrder" class="add-button btn btn-primary" translate aria-label="Center Align"> <em class="fas fa-download mr-2"></em>lblDownload </button>
 &nbsp;&nbsp; <button type="button" (click)="printPdf(2)"    *ngIf="isDownloadOrder" type="reset" class="add-button btn btn-primary" translate aria-label="Center Align"> <em class="fas fa-print mr-2"></em>lblPrint </button>


<!--pdf content-->
<div id="content" [hidden]="!isView" #content style="margin: 0; padding: 0; width: 600px; font-size: 6pt;font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">

  <div class="p-0">

    <div class="head p-2 px-4">
      <div class="row d-flex align-items-center">
        <div class="col-auto mr-auto">
        </div>
      </div>
    </div>

    <div class="p-4 pdf-cnt ">
      <div class="row">


        <div class="col-md-10">
          <div class="row ">
            <div class="col-md-3">
              <div style="font-weight: bold; 
             font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">
                  {{contactDetails.customerName}}
              </div>
              <p style="margin:0; line-height: 1em !important;">{{contactDetails.address}}</p>
            </div>
            <div class="col-md-4">
              <address style="line-height: 1em;" class="mb-2">
                <span style="line-height: normal;font-weight: bold;"> Dealer&nbsp; Address:</span> <br>
                {{contactDetails.dealerName}}<br />
                {{dealerDetails.address1}}<br />
                {{dealerDetails.address2}}
              </address>


              <address style=" line-height: 1em;" class="mb-2">
                <strong> Telephone:</strong> <br /><span style="font-size: .9em;" *ngIf="dealerDetails.mobile > 0">{{dealerDetails.mobile}}</span>
              </address>
            </div>
            <div class="col-md-5">
              <address style=" line-height: 1em;" class="mb-2">
                <strong> Date:</strong>
                <br /><span style="font-weight:normal;">{{TodayDate | date:'shortDate'}}</span>
              </address>
              <address style="font-size: .9em;  line-height: 1em;" class="mb-2">
                <strong style="font-size: .9em;"> E-mail: </strong>
                <br /><span style="font-weight:normal; word-break: break-all;">{{dealerDetails.email}}</span>
              </address>
              <address style=" line-height: 1em;" class="mb-2">
                <strong>Order&nbsp; Date:</strong>
                <br /><span style="font-weight:normal;">
                  {{contactDetails.bookedDate}}
                </span>
              </address>
              <address style=" line-height: 1em;" class="mb-2"
                *ngIf="contactDetails && contactDetails?.isPickUpDropOffService">
                <strong>PickUp&nbsp; Time: </strong>
                <br /><span style="font-weight:normal; ">{{contactDetails.pickUpDateTime|date:'short'}}</span>
              </address>
            </div>
          </div>
        </div>

        <div class="col-auto ml-auto d-flex align-items-center">
            <ng-container *ngIf="appointmentDetails && appointmentDetails.brand">
              <img [src]="'../../../../../../assets/images/brandLogo/' + appointmentDetails.brandCode + '.png'"
              height="35px" alt="">
            </ng-container>
        </div>
      </div>


      <!--order confirmation with price-->
      <div *ngIf="id==1">
        <div class="row mt-4 orderConfirmation" style="padding-bottom:5px !important; padding-top: 5px !important;">
          <div class="col-md-12">
            <h6><strong>Order&nbsp; Confirmation</strong></h6>
            <p class="mt-2">
              We thank you for ordering a workshop appointment and confirm that we have set aside time for your
              <strong>{{contactDetails.modelName}}</strong>&nbsp; with registration number
              <strong>{{contactDetails.licensePlate}}.</strong>
            </p>
            <table class="table mt-3" style="border-spacing: 0;">
              <thead>
                <tr style="background-color:lightgray;">
                  <th scope="col" class="pl-1" style="font-weight: normal; background-color:lightgray; width: 40%; ">Ordered&nbsp;
                    Services</th>
                  <th scope="col" class=""
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;"></th>
                  <th scope="col" class=""
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">Price
                    without VAT</th>
                  <th scope="col" class="pr-1"
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-left: none;">Price
                    with VAT</th>
                </tr>
              </thead>

              <ng-container *ngIf="invoiceData?.length>0; else load_else">
                <tbody *ngFor="let data of invoiceData; let in=index" style="border: 0;">
                  <tr>
                    <th scope="col" colspan="3" style=" font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;" class="font-weight-bold pl-1">{{data.invoiceJobLists[0].description}}

                      <ng-container *ngIf="data.invoiceDemand.fixedPrice" class="font-weight-light">
                        &nbsp;(Fixed Price Job)
                      </ng-container>

                    </th>
                    <th scope="col" style="text-align: right;" class="pr-1">
                      <span *ngIf="data.invoiceDemand.fixedPrice && data.invoiceJobDetailsLists.length===0">
                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                      </span>
                    </th>
                  </tr>
                  <ng-container *ngIf="!data.invoiceDemand.fixedPrice;else load_elsefixedPrice">
                    <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;">
                      <td style="line-height: normal !important;" class="pl-1">-{{jobDetail.description}}</td>
                      <td></td>
                      <td style="text-align: right;">
                        <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceExcVAT">
                          <ng-container *ngIf="jobDetail.fixedPrice; else elseJobFixedPrice">
                            {{jobDetail.fixedPrice | number:'1.2-2'}}
                          </ng-container>
                          <ng-template #elseJobFixedPrice>
                            {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                          </ng-template>
                        </ng-container>
                        <ng-template #elsePriceExcVAT>
                          {{jobDetail.salesPriceAmount | number:'1.2-2'}}
                        </ng-template>
                      </td>
                      <td style="text-align: right;" class="pr-1">
  
                        <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceInclVAT">
                          <ng-container *ngIf="jobDetail.fixedPrice; else elseJobFixedPriceInclVAT">
                            {{jobDetail.fixedPrice | number:'1.2-2'}}
                          </ng-container>
                          <ng-template #elseJobFixedPriceInclVAT>
                            {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                          </ng-template>
                        </ng-container>
                        <ng-template #elsePriceInclVAT>
                          {{jobDetail.salesPriceAmountVAT | number:'1.2-2'}}
                        </ng-template>
                      </td>
                    </tr>
                </ng-container>
                <ng-template #load_elsefixedPrice>
                    <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;let i = index">
                      <td style="line-height: normal !important;" class="pl-1">-{{jobDetail.description}}</td>
                      <td ></td>
                      <td style="text-align: right;vertical-align: middle;" *ngIf="i===0" [attr.rowspan]="data.invoiceJobDetailsLists.length">  {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}</td>
                      <td style="text-align: right;vertical-align: middle;" class="pr-1" *ngIf="i===0" [attr.rowspan]="data.invoiceJobDetailsLists.length"> {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}</td>
                    </tr>
                </ng-template>

                  <tr style="border-bottom:1px solid black !important;" class="font-weight-bold">
                    <td class="pl-1 pb-0 font-weight-bold">Sum</td>
                    <td></td>
                    <td style="text-align: right;" class="font-weight-bold">
                    </td>
                    <td style="text-align: right;" class="pr-1 font-weight-bold">
                      <ng-container *ngIf="data.invoiceJobLists[0].fixedPrice; else elsePriceInclVATSum">
                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                      </ng-container>
                      <ng-template #elsePriceInclVATSum>
                        {{data.invoiceJobLists[0].salesPriceAmountVAT | number:'1.2-2'}}
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </ng-container>

              <tbody style="border: 0;">
                <ng-container *ngIf="isShowTax">
                <tr>
                  <th scope="col">
                  </th>
                  <th scope="col" class="pl-1">
                    Personnel Tax <span>({{contactDetails.personnelTax}}%)</span>
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right pr-1">
                    {{ serviceDetail.invoicePriceLists[0].personnelTax | number:'1.2-2'}}
                  </th>
                </tr>

                <tr>
                  <th scope="col">
                  </th>
                  <th scope="col" class="pl-1">
                    Material Tax <span>({{contactDetails.materialTax}}%)</span>
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right pr-1">
                    {{ serviceDetail.invoicePriceLists[0].materialTax | number:'1.2-2'}}
                  </th>
                </tr>
                <tr class="font-weight-bold">
                  <th scope="col">
                  </th>
                  <th scope="col" class="pl-1 font-weight-bold">
                    Sum
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right pr-1 font-weight-bold">
                    {{ serviceDetail.invoicePriceLists[0].materialTax+serviceDetail.invoicePriceLists[0].personnelTax |
                    number:'1.2-2'}}
                  </th>
                </tr>
                
              </ng-container>

              <tr style="border-bottom:1px solid black !important;">

                <th scope="col" class="pl-1 font-weight-bold ">
                  Total&nbsp; Price&nbsp;
                </th>
                <th scope="col">
                </th>
                <th scope="col">
                </th>
                <th scope="col" class="text-right font-weight-bold pr-1">
                  {{ serviceDetail.invoicePriceLists[0].totalPrice | number:'1.2-2'}}
                </th>
              </tr>
               
                <tr>
                  <th scope="col" class="pl-1">
                    Rounding
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right pr-1">         
                    <span *ngIf="showMinusRoundOff">-</span>
                    {{ roundOff | number:'1.2-2'}}
                  </th>
                </tr>
                <tr style="border-bottom:1px solid black !important;">
                  <th scope="col" class="pl-1 font-weight-bold ">
                    Total&nbsp;
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right font-weight-bold pr-1">
                    {{ serviceDetail.invoicePriceLists[0].total | number:'1.2-2'}}
                  </th>
                </tr>
                <tr>
                  <th scope="col" class="pl-1">
                    Of which VAT ({{ serviceDetail.invoicePriceLists[0].vatPercentage}}%)
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right pr-1">
                    {{ serviceDetail.invoicePriceLists[0].vatPrice | number:'1.2-2'}}
                  </th>

                </tr>
              </tbody>

              <br />
              <tbody>
                <tr *ngIf="contactDetails.vehicleId" style="background-color:lightgray;">
                  <th scope="col" style="font-weight: normal; background-color:lightgray;" class="pl-1">Rental Service</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="pr-1" style="text-align: right; font-weight: normal; background-color:lightgray;">Price
                  </th>
                </tr>
                <tr *ngIf="contactDetails.vehicleId">
                  <td translate class="pl-1">Rented Car - {{ contactDetails.rentalCompanyMakeName }}</td>
                  <td></td>
                  <td></td>
                  <td style="text-align: right;" class="pr-1">
                    {{contactDetails.price | number:'1.2-2' }}
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <p>
              You can contact us if you find that something is wrong, unclear or that something is missing.
              If you come up with something more to be carried out when the car is in the workshop, then we ask you to
              contact us in advance so that we can plan for both time and any parts to fix it.
            </p>
            <p class="mt-3">
              With best regards,
            </p>
            <p>{{contactDetails.dealerName}}</p>
            <div class="row mt-5">
              <div class="col-md-6">
                <p class="pt-3 pb-5 font-size: 8px;"> Dealer's signature:__________________ </p>
              </div>
              <div class="col-md-6">
                <p class=" pt-3 pb-5 font-size: 8px;">Customer's signature:__________________</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--Order confimation without price-->
      <div *ngIf="id==2">
        <div class="row mt-4" style="padding-bottom:5px !important; padding-top: 5px !important;">
          <div class="col-md-12">
            <h6><strong>Order&nbsp; Confirmation</strong></h6>
            <p class="mt-2">
              We thank you for ordering a workshop appointment and confirm that we have set aside time for your
              <strong>{{contactDetails.modelName}}</strong>&nbsp; with registration number
              <strong>{{contactDetails.licensePlate}}</strong>.
            </p>
            <table class="table  mt-3">
              <thead>
                <tr style="background-color:lightgray;">
                  <th scope="col" class="pl-1" style="font-weight: normal; background-color:lightgray; width: 50%; ">Ordered&nbsp;
                    Services</th>
                  <th scope="col" class=" " style="font-weight: normal; background-color:lightgray;   text-align: right;"></th>
                  <th scope="col" class="pr-1" style="font-weight: normal; background-color:lightgray;   text-align: right;"></th>
                </tr>
              </thead>

              <ng-container *ngIf="invoiceData?.length>0; else load_else">
                <tbody *ngFor="let data of invoiceData; let in=index"
                  style="border: 0;border-bottom:1px solid black !important;">
                  <tr>
                    <th scope="col" colspan="4" style=" font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;" class="font-weight-bold pl-1">{{data.invoiceJobLists[0].description}}

                    </th>
                  </tr>
                  <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;">
                    <td style="line-height: normal !important;" class="pl-1">-{{jobDetail.description}}</td>
                    <td></td>
                    <td style="text-align: right;">
                    </td>
                    <td style="text-align: right;" class="pr-1">
                    </td>
                  </tr>


                </tbody>
              </ng-container>


              <br />
              <tbody>
                <tr *ngIf="contactDetails.vehicleId" style="background-color:lightgray;">
                  <th scope="col" class="pl-1" style="font-weight: normal; background-color:lightgray;">Rental Service</th>
                  <th scope="col"></th>
                  <th scope="col" class="pr-1" style="text-align: right; font-weight: normal; background-color:lightgray;">Price
                  </th>
                </tr>
                <tr *ngIf="contactDetails.vehicleId">
                  <td translate class="pl-1">Rented Car -</td>
                  <td></td>
                  <td style="text-align: right;" class="pr-1">
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>
        <div class="row mt-3">
          <div class="col-md-12">
            <p style="font-size: 10px;">
              You can contact us if you find that something is wrong, unclear or that something is missing.
              If you come up with something more to be carried out when the car is in the workshop, then we ask you to
              contact us in advance so that we can plan for both time and any parts to fix it.
            </p>

            <p class="mt-3">
              With best regards,
            </p>
            <p style="font-size: 10px;">{{contactDetails.dealerName}}</p>
            <div class="row mt-5">
              <div class="col-md-6">
                <p class="pt-3 pb-5" style="font-size: 10px;"> Dealer's signature:________________________ </p>
              </div>
              <div class="col-md-6">
                <p class=" pt-3 pb-5" style="font-size: 10px;">Customer's signature:________________________</p>
              </div>
            </div>
          </div>

        </div>
      </div>


      <!--offer-->
      <div *ngIf="id==3">
        <div class="row mt-3" style="padding-bottom:5px !important; padding-top: 5px !important;">
          <div class="col-md-12">
            <h6><strong>Offer</strong></h6>
            <p class="mt-3">Thank you for your request for a car <strong>{{contactDetails.modelName}}
              </strong>&nbsp;with registration number
              <strong>{{contactDetails.licensePlate}}</strong>. Below you will find all the details
              and prices for the offer. The offer is valid for 30 days unless otherwise stated.
            </p>
            <table class="table  mt-3" >
              <thead>
                <tr style="background-color:lightgray;">
                  <th scope="col" class="pl-1" style="font-weight: normal; background-color:lightgray; width: 40%; ">Ordered&nbsp;
                    Services</th>
                  <th scope="col" class=""
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;"></th>
                  <th scope="col" class=""
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">Price
                    without VAT</th>
                  <th scope="col" class="pr-1"
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-left: none;">Price
                    with VAT</th>
                </tr>
              </thead>

              <tbody *ngFor="let d of demList; let in=index" style="border: 0;">
                <tr>
                  <th scope="col" colspan="4" class="font-weight-bold pl-1">{{d.shortDescription}}</th>
                </tr>
                <tr *ngFor="let J of d.demandJobList;">
                  <td style="line-height: normal !important;" class="pl-1 ">-{{J.description}}</td>
                  <td></td>
                  <td style="text-align: right;">
                    <ng-container *ngIf="J.fixedPrice; else elsePriceExcVATOffer">
                      {{J.fixedPrice | number:'1.2-2'}}
                    </ng-container>
                    <ng-template #elsePriceExcVATOffer>
                      {{J.salesPriceAmount | number:'1.2-2'}}
                    </ng-template>
                  </td>
                  <td style="text-align: right;" class="pr-1">
                    <ng-container *ngIf="J.fixedPrice; else elsePriceInclVATOffer">
                      {{J.fixedPrice | number:'1.2-2'}}
                    </ng-container>
                    <ng-template #elsePriceInclVATOffer>
                      {{J.salesPriceAmountVAT | number:'1.2-2'}}
                    </ng-template>
                  </td>
                </tr>
                <tr style="border-bottom:1px solid black !important;" class="font-weight-bold">
                  <td class="pl-1 pb-0 font-weight-bold">Sum</td>
                  <td></td>
                  <td style="text-align: right;" class="font-weight-bold">
                    {{d.sumPerServiceExclVAT | number:'1.2-2'}}
                  </td>
                  <td style="text-align: right;" class="pr-1 font-weight-bold">
                    {{d.sumPerServiceInclVAT | number:'1.2-2'}}
                  </td>
                </tr>
              </tbody>
              <ng-container *ngIf="invoiceData?.length>0; else load_else">
                <tbody *ngFor="let data of invoiceData; let in=index" style="border: 0;">
                  <tr>
                    <th scope="col" colspan="3" style=" font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;" class="font-weight-bold pl-1">{{data.invoiceJobLists[0].description}}
                      <ng-container *ngIf="data.invoiceDemand.fixedPrice" class="font-weight-light">
                        &nbsp;(Fixed Price Job)
                      </ng-container>
                    </th>
                    <th scope="col" style="text-align: right;" class="pr-1">
                      <span *ngIf="data.invoiceDemand.fixedPrice && data.invoiceJobDetailsLists.length===0">
                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                      </span>
                    </th>
                  </tr>
                  <ng-container *ngIf="!data.invoiceDemand.fixedPrice;else load_elsefixedPriceOffer">
                  <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;">
                    <td style="line-height: normal !important;" class="pl-1">-{{jobDetail.description}}</td>
                    <td></td>
                    <td style="text-align: right;">
                      <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceExcVAT">
                        <ng-container *ngIf="jobDetail.fixedPrice; else elseJobFixedPrice">
                          {{jobDetail.fixedPrice | number:'1.2-2'}}
                        </ng-container>
                        <ng-template #elseJobFixedPrice>
                          {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                        </ng-template>
                      </ng-container>
                      <ng-template #elsePriceExcVAT>
                        {{jobDetail.salesPriceAmount | number:'1.2-2'}}
                      </ng-template>
                    </td>
                    <td style="text-align: right;" class="pr-1">

                      <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceInclVAT">
                        <ng-container *ngIf="jobDetail.fixedPrice; else elseJobFixedPriceInclVAT">
                          {{jobDetail.fixedPrice | number:'1.2-2'}}
                        </ng-container>
                        <ng-template #elseJobFixedPriceInclVAT>
                          {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                        </ng-template>
                      </ng-container>
                      <ng-template #elsePriceInclVAT>
                        {{jobDetail.salesPriceAmountVAT | number:'1.2-2'}}
                      </ng-template>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_elsefixedPriceOffer>
                    <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;let i = index">
                      <td style="line-height: normal !important;" class="pl-1">-{{jobDetail.description}}</td>
                      <td ></td>
                      <td style="text-align: right;vertical-align: middle;" *ngIf="i===0" [attr.rowspan]="data.invoiceJobDetailsLists.length">  {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}</td>
                      <td style="text-align: right;vertical-align: middle;" class="pr-1" *ngIf="i===0" [attr.rowspan]="data.invoiceJobDetailsLists.length"> {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}</td>
                    </tr>
                </ng-template>
                  <tr style="border-bottom:1px solid black !important;" class="font-weight-bold">
                    <td class="pl-1 pb-0 font-weight-bold">Sum</td>
                    <td></td>
                    <td style="text-align: right;" class="font-weight-bold">
                    </td>
                    <td style="text-align: right;" class="pr-1 font-weight-bold">
                      <ng-container *ngIf="data.invoiceJobLists[0].fixedPrice; else elsePriceInclVATSum">
                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                      </ng-container>
                      <ng-template #elsePriceInclVATSum>
                        {{data.invoiceJobLists[0].salesPriceAmountVAT | number:'1.2-2'}}
                      </ng-template>
                    </td>
                  </tr>
                </tbody>
              </ng-container>

              <tbody style="border: 0;">

                <ng-container *ngIf="isShowTax">
                <tr>
                  <td>
                  </td>
                  <td class="pl-1">
                     Personnel Tax <span>({{contactDetails.personnelTax}}%)</span>
                  </td>
                
                  <td class="pl-1" style="text-align: center;">
                    <ng-container *ngIf="serviceDetail.invoicePriceLists?.length > 0; else load_ptax">
                    {{((serviceDetail.invoicePriceLists?.length > 0 && serviceDetail.invoicePriceLists[0].personnelTax > 0) ? serviceDetail.invoicePriceLists[0].personnelTax : '0') | number:'1.2-2'}}
                  </ng-container>
                  <ng-template  #load_ptax>
                    0,00
                  </ng-template>
                  </td> 
                  <td>
                  </td>
                </tr>

                <tr>
                  <th scope="col">
                  </th>
                  <th scope="col" class="pl-1">
                     Material Tax <span>({{contactDetails.materialTax}}%)</span>
                  </th>
                
                 <th class="pl-1" id="materialTax" style="text-align: center;">
                   <ng-container *ngIf="serviceDetail.invoicePriceLists?.length > 0; else load_zero_mtax">
                   {{ serviceDetail.invoicePriceLists[0].materialTax | number:'1.2-2'}}
                 </ng-container>
                 <ng-template scope="col" style="margin-right: 8px;" #load_zero_mtax>
                   0,00
                 </ng-template>
                 </th>
                 <td class="pl-5">
                </td>
                </tr>
                <tr class="font-weight-bold">
                  <th scope="col">
                  </th>
                  <th scope="col" class="pl-1 font-weight-bold">
                    Sum
                  </th>
                  <td class="ml-15">
                   </td>
                   <th scope="col" class="text-right pr-1 font-weight-bold">
                     <ng-container  *ngIf="serviceDetail.invoicePriceLists?.length > 0; else load_sum" >
                     {{serviceDetail.invoicePriceLists[0].materialTax+serviceDetail.invoicePriceLists[0].personnelTax |
                     number:'1.2-2'}}
                   </ng-container>
                   <ng-template scope="col" class="text-right pr-1 font-weight-bold" #load_sum>
                     0,00
                    </ng-template>
                   </th>
                </tr>
              </ng-container>

                <tr style="border-bottom:1px solid black !important;">

                  <th scope="col" class="pl-1 font-weight-bold ">
                    Total&nbsp; Price&nbsp;
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right font-weight-bold pr-1">
                    {{ (serviceDetail.invoicePriceLists?.length > 0 && serviceDetail.invoicePriceLists[0].totalPrice > 0) ? serviceDetail.invoicePriceLists[0].totalPrice : 0 | number:'1.2-2'}}
                  </th>
                </tr>
                
                
                <tr>
                  <th scope="col" class="pl-1">
                    Rounding
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right pr-1">
                    <span *ngIf="showMinusRoundOff">-</span>
                    {{ roundOff | number:'1.2-2'}}
                  </th>
                </tr>
                <tr style="border-bottom:1px solid black !important;">
                  <th scope="col" class="pl-1 font-weight-bold ">
                    Total&nbsp;
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right font-weight-bold pr-1">
                    {{(serviceDetail.invoicePriceLists?.length > 0 && serviceDetail.invoicePriceLists[0].total > 0) ? serviceDetail.invoicePriceLists[0].total : 0 | number:'1.2-2'}}
                  </th>
                </tr>
                <tr>
                  <th scope="col" class="pl-1">
                    Of which VAT ({{ serviceDetail.invoicePriceLists?.length > 0 ? serviceDetail.invoicePriceLists[0].vatPercentage : 0}}%)
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col">
                  </th>
                  <th scope="col" class="text-right pr-1">
                    {{ serviceDetail.invoicePriceLists?.length > 0 ? serviceDetail.invoicePriceLists[0].vatPrice : 0 | number:'1.2-2'}}
                  </th>
                </tr>
              </tbody>

              <br />
              <tbody>
                <tr *ngIf="contactDetails.vehicleId" style="background-color:lightgray;">
                  <th scope="col" style="font-weight: normal; background-color:lightgray;" class="pl-1">Rental Service</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="pr-1" style="text-align: right; font-weight: normal; background-color:lightgray;">Price
                  </th>
                </tr>
                <tr *ngIf="contactDetails.vehicleId">
                  <td translate class="pl-1">Rented Car - {{ contactDetails.rentalCompanyMakeName }}</td>
                  <td></td>
                  <td></td>
                  <td style="text-align: right;" class="pr-1">
                    {{contactDetails.price | number:'1.2-2' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">

            <p style="font-size: 10px;">Contact us if you find that something is wrong, unclear or that someone is
              missing. If you come up with something out of the ordinary, then they have to re-think their position
              carried out when the car is in the workshop, we ask you to contact us in advance so that we can plan both
              time and any parts
              to fix it.</p>

            <p class="mt-3" style=" font-size: 10px; ">With best regards
            </p>
            <p style="font-size: 10px;">{{contactDetails.dealerName}}</p>
            <div class="row mt-5">
              <div class="col-md-6">
                <p class="pt-3 pb-5" style="font-size: 10px;">Dealer's signature:________________________ </p>
              </div>
              <div class="col-md-6">
                <p class=" pt-3 pb-5" style="font-size: 10px;">Customer's signature:________________________</p>
              </div>
            </div>
          </div>

        </div>
      </div>



      <!--Invoice-->
      <div *ngIf="id==4">
        <div class="row mt-3" style="padding-bottom:5px !important; padding-top: 5px !important;">
          <div class="col-md-12">
            <h6><strong>Order&nbsp; Confirmation</strong></h6>
            <p class="mt-3">
              We thank you for ordering a workshop appointment and confirm that we have set aside time for your
              <strong>{{contactDetails.modelName}} </strong>&nbsp;with registration number
              <strong>{{contactDetails.licensePlate}}</strong>.

            </p>
            <table class="table  mt-3">
              <thead>
                <tr style="background-color:lightgray;">
                  <th scope="col" class="pl-1" style="font-weight: normal; background-color:lightgray; width: 25%; ">Ordered&nbsp;
                    Services</th>
                  <th scope="col" class=""
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">
                    Qty</th>
                  <th scope="col" class=""
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">Unit
                    Price</th>
                  <th scope="col" class=""
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">Price
                    without VAT</th>
                  <th scope="col" class="pr-1"
                    style="text-align: right;font-weight: normal; background-color:lightgray;border-left: none;">Price
                    with VAT</th>
                </tr>
              </thead>

              <ng-container *ngIf="invoiceData?.length>0; else load_else">
                <tbody *ngFor="let data of invoiceData; let in=index" style="border: 0;">
                  <tr>
                    <th scope="col" colspan="4" style=" font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;" class="font-weight-bold pl-1">{{data.invoiceJobLists[0].description}}

                      <ng-container *ngIf="data.invoiceDemand.fixedPrice" class="font-weight-light">
                        &nbsp;(Fixed&nbsp; Price&nbsp; Job)
                      </ng-container>

                    </th>
                    <th scope="col" style="text-align: right;" class="pr-1">
                      <span *ngIf="data.invoiceDemand.fixedPrice && data.invoiceJobDetailsLists.length===0">
                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                      </span>
                    </th>
                  </tr>
                  <ng-container *ngIf="!data.invoiceDemand.fixedPrice;else load_elsefixedPriceInvoice">
                  <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;">
                    <td style="line-height: normal !important;" class="pl-1">-{{jobDetail.description}}</td>
                    <td style="text-align: right;">
                      <ng-container *ngIf="jobDetail.costType==='Material'" class="font-weight-light">
                        {{jobDetail.plannedQuantity}}
                      </ng-container>
                    </td>
                    <td style="text-align: right;">
                      {{jobDetail.unitPrice | number:'1.2-2'}}
                    </td>
                    <td style="text-align: right;">
                      <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceExcVAT">
                        <ng-container *ngIf="jobDetail.fixedPrice; else elseJobFixedPrice">
                          {{jobDetail.fixedPrice | number:'1.2-2'}}
                        </ng-container>
                        <ng-template #elseJobFixedPrice>
                          {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                        </ng-template>
                      </ng-container>
                      <ng-template #elsePriceExcVAT>
                        {{jobDetail.salesPriceAmount | number:'1.2-2'}}
                      </ng-template>
                    </td>
                    <td style="text-align: right;" class="pr-1">

                      <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceInclVAT">
                        <ng-container *ngIf="jobDetail.fixedPrice; else elseJobFixedPriceInclVAT">
                          {{jobDetail.fixedPrice | number:'1.2-2'}}
                        </ng-container>
                        <ng-template #elseJobFixedPriceInclVAT>
                          {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                        </ng-template>
                      </ng-container>
                      <ng-template #elsePriceInclVAT>
                        {{jobDetail.salesPriceAmountVAT | number:'1.2-2'}}
                      </ng-template>

                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_elsefixedPriceInvoice>
                    <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;let i = index">
                      <td style="line-height: normal !important;" class="pl-1">-{{jobDetail.description}}</td>
                      <td style="text-align: right;">
                        <ng-container *ngIf="jobDetail.costType==='Material'" class="font-weight-light">
                          {{jobDetail.plannedQuantity}}
                        </ng-container>
                      </td>
                      <td style="text-align: right;">
                        {{jobDetail.unitPrice | number:'1.2-2'}}
                      </td>
                      <td style="text-align: right;vertical-align: middle;" *ngIf="i===0" [attr.rowspan]="data.invoiceJobDetailsLists.length">  {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}</td>
                      <td style="text-align: right;vertical-align: middle;" class="pr-1" *ngIf="i===0" [attr.rowspan]="data.invoiceJobDetailsLists.length"> {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}</td>
                    </tr>
                </ng-template>
                  <tr style="border-bottom:1px solid black !important;border-top:1px solid black !important;"
                    class="font-weight-bold">
                    <td class="pl-1 pb-0 font-weight-bold">Sum</td>
                    <td></td>
                    <td></td>
                    <td style="text-align: right;" class="font-weight-bold">


                    </td>
                    <td style="text-align: right;" class="pr-1 font-weight-bold">
                      <ng-container *ngIf="data.invoiceJobLists[0].fixedPrice; else elsePriceInclVATSum">

                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                      </ng-container>
                      <ng-template #elsePriceInclVATSum>
                        {{data.invoiceJobLists[0].salesPriceAmountVAT | number:'1.2-2'}}
                      </ng-template>

                    </td>
                  </tr>

                </tbody>
              </ng-container>



              <tbody style="border: 0;">

                <ng-container *ngIf="isShowTax">
                <tr>
                  <th scope="col"></th>
                  <th scope="col" class="pl-1">
                     Personnel Tax <span>({{contactDetails.personnelTax}}%)</span>
                  </th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="text-right pr-1">
                    {{ serviceDetail.invoicePriceLists[0].personnelTax | number:'1.2-2'}}
                  </th>
                </tr>

                <tr>
                  <th scope="col"></th>
                  <th scope="col" class="pl-1">
                    Material Tax <span>({{contactDetails.materialTax}}%)</span>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="text-right pr-1">
                    {{ serviceDetail.invoicePriceLists[0].materialTax | number:'1.2-2'}}
                  </th>
                </tr>
                <tr class="font-weight-bold"
                  style="border-bottom:1px solid black !important;border-top:1px solid black !important;">
                  <th scope="col"></th>
                  <th scope="col" class="pl-1  font-weight-bold">
                    Sum
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="text-right pr-1  font-weight-bold">
                    {{ serviceDetail.invoicePriceLists[0].materialTax+serviceDetail.invoicePriceLists[0].personnelTax |
                    number:'1.2-2'}}
                  </th>
                </tr>
              </ng-container>
                <tr style="border-bottom:1px solid black !important;">

                  <th scope="col" class="pl-1 font-weight-bold ">
                    Total&nbsp; Price&nbsp;
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="text-right font-weight-bold pr-1">
                    {{ serviceDetail.invoicePriceLists[0].totalPrice | number:'1.2-2'}}
                  </th>
                </tr>
                
                
                <tr>
                  <th scope="col" class="pl-1">
                    Rounding
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="text-right pr-1">
                    <span *ngIf="showMinusRoundOff">-</span>
                    {{ roundOff | number:'1.2-2'}}
                  </th>
                </tr>
                <tr style="border-bottom:1px solid black !important;">
                  <th scope="col" class="pl-1 font-weight-bold ">
                    Total&nbsp;
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="text-right font-weight-bold pr-1">
                    {{ serviceDetail.invoicePriceLists[0].total | number:'1.2-2'}}
                  </th>
                </tr>
                <tr>
                  <th scope="col" class="pl-1">
                    Of which VAT ({{ serviceDetail.invoicePriceLists[0].vatPercentage}}%)
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="text-right pr-1">
                    {{ serviceDetail.invoicePriceLists[0].vatPrice | number:'1.2-2'}}
                  </th>
                </tr>
              </tbody>

              <br />
              <tbody>
                <tr *ngIf="contactDetails.vehicleId" style="background-color:lightgray;">
                  <th scope="col" style="font-weight: normal; background-color:lightgray;" class="pl-1">Rental Service</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col" class="pr-1" style="text-align: right; font-weight: normal; background-color:lightgray;">Price
                  </th>
                </tr>
                <tr *ngIf="contactDetails.vehicleId">
                  <td translate class="pl-1">Rented Car - {{ contactDetails.rentalCompanyMakeName }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="text-align: right;" class="pr-1">
                    {{contactDetails.price | number:'1.2-2' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12">

            <p style="font-size: 10px;">Contact us if you find that something is wrong, unclear or that someone is
              missing. Are you coming
              for something further you want done when the car is in the workshop, we ask you to contact
              in advance so that we can plan in both time and any parts to arrange it.</p>

            <p class="mt-3" style=" font-size: 10px; ">With best regards
            </p>
            <p style="font-size: 10px;">{{contactDetails.dealerName}}</p>
            <div class="row mt-5">
              <div class="col-md-6">
                <p class="pt-3 pb-5" style="font-size: 10px;">Digital signature</p>
                <p class="pt-3 pb-5" style="font-size: 10px;">The customer's signature:________________________ </p>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>


  </div>
</div>